<template>
  <div class="page-container">
    <div class="content-banner">
      <img
        src="@/assets/images/category-commission-campaigns-banner.png"
        alt="Kategori Komisyon Kampanyaları"
      >
    </div>
    <div class="title-header">
      <div class="title">
        Kategori Komisyon Kampanyaları
      </div>
      <div
        class="video-link"
        @click="onWatchVideoClick"
      >
        <Icons
          name="Video"
          size="sm"
          color="#242424"
        />
        <span>Eğitim Videolarını İzle</span>
      </div>
    </div>
    <CampaignPromotion @join-success="onJoinSuccess" />
    <CampaignsTable ref="campaignsTableRef" />
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import { Icons } from '@n11/so-ui-components';
import {
  sendCategoryCommissionButtonClickEvent,
  sendPageViewEvent,
} from '@/utils/ga4/helper';
import { PAGE_TYPE } from './constants';
import CampaignPromotion from './CampaignPromotion';
import CampaignsTable from './partials/CampaignsTable';

const store = useStore();
const sellerInfo = computed(() => ({
  sellerId: store.state.auth.user.sellerId || '',
  sellerName: store.state.auth.user.username || '',
}));

const campaignsTableRef = ref(null);

const onWatchVideoClick = () => {
  sendCategoryCommissionButtonClickEvent({
    button_name: 'Eğitim Videolarını İzle',
    page_type: PAGE_TYPE,
    seller_name: sellerInfo.value.sellerName,
    seller_id: sellerInfo.value.sellerId,
  });

  window.open(
    'https://magazadestek.n11.com/egitim-detay/promosyon-kodu-ile-komisyon-kampanyalarina-nasil-katilabilirim-23170',
    '_blank',
    'noopener,noreferrer',
  );
};

onMounted(() => {
  sendPageViewEvent({
    page_type: PAGE_TYPE,
    seller_name: sellerInfo.value.sellerName,
    seller_id: sellerInfo.value.sellerId,
  });
});

const onJoinSuccess = () => {
  if (campaignsTableRef.value?.fetchCampaignsByTab) {
    campaignsTableRef.value.fetchCampaignsByTab(
      campaignsTableRef.value.activeTab,
      { resetPage: true },
    );
  }
};
</script>

<style scoped lang="scss">
@import '@/assets/styles/variables';

.page-container {
  display: flex;
  width: 100%;
  flex-direction: column;

  .content-banner {
    width: 100%;
    border-radius: 8px;
    overflow: hidden;
    margin-top: 16px;

    img {
      width: 100%;
      height: auto;
      display: block;
      object-fit: cover;
    }
  }

  :deep(.simpleSelect-btn) {
    width: 125px !important;
  }

  .title-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 0;
    .title {
      font-size: 20px;
      font-weight: 700;
      line-height: 26px;
      letter-spacing: -0.2px;
      color: $colorN80;
    }
    .video-link {
      display: flex;
      align-items: center;
      gap: 4px;
      cursor: pointer;
      border-radius: 6px;
      border: 0.5px solid $colorN80;
      background: $colorN00;
      padding: 12px 24px;

      span {
        font-size: 14px;
        font-weight: 600;
        line-height: 18px;
        letter-spacing: -0.05px;
      }
    }
  }
}
</style>
